import useCloudPermissions from "../../hooks/useCloudPermissions";
import DropdownOptionWithIcon from "../Menus/DropdownOptionWithIcon";
import PopoverDropdownMenu from "../Menus/PopoverDropdownMenu";

interface Props {
  user: any;
  userPermissionProfile: any;
  isCurrentUser: boolean;
  isCurrentUserOwner: boolean;
  setManageUser: any;
  removeUser: any;
  transferOwner: any;
}

const RegisteredUserOptions = ({
  user,
  userPermissionProfile,
  isCurrentUser,
  isCurrentUserOwner = false,
  setManageUser,
  removeUser,
  transferOwner,
}: Props) => {
  const { cPermissions } = useCloudPermissions();
  const userCanModify = userPermissionProfile.Scopes.includes(
    "cloud_modify_permissions"
  );
  const userCanDelete = userPermissionProfile.Scopes.includes(
    "cloud_delete_person"
  );

  return (
    <PopoverDropdownMenu>
      <DropdownOptionWithIcon
        name="Manage Permissions"
        onClick={() => setManageUser(user)}
        icon="mdi mdi-pencil"
        disabled={
          isCurrentUser ||
          (userCanModify && !isCurrentUserOwner) ||
          !cPermissions.cloud_modify_permissions
        }
        tooltip={
          cPermissions.cloud_modify_permissions
            ? undefined
            : "You don't have permission to manage permissions"
        }
      />
      {!isCurrentUser &&
        (!userCanDelete || isCurrentUserOwner) &&
        cPermissions.cloud_delete_person && (
          <DropdownOptionWithIcon
            name="Remove User"
            onClick={() => removeUser(user)}
            icon="mdi mdi-delete"
          />
        )}
      {!isCurrentUser && isCurrentUserOwner && (
        <DropdownOptionWithIcon
          name="Set As Owner"
          onClick={() => transferOwner(user)}
          icon="mdi mdi-crown"
        />
      )}
    </PopoverDropdownMenu>
  );
};

export default RegisteredUserOptions;
